import React from "react"

import PropTypes from "prop-types"

import * as styles from "./title.module.scss"
import DarkColor from "../../../helpers/dark-color"
import Wrapper from "../wrapper"

const Title = ({ color, children }) => (
  <div
    className={`${styles.title} ${styles[`title__${color}`]} ${DarkColor(color) ? styles.title__dark : ""}`}
  >
    <Wrapper
      container
      className={`${styles.wrapper} ${styles[`wrapper__${color}`]}`}
    >
      {children}
    </Wrapper>
  </div>
)
export default Title

Title.propTypes = {
  color: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}
